<template>
  <div></div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import printJS from 'print-js';

/** Margen del PDF generado (html2pdf/jsPDF, unidad mm). No afecta las pantallas de la app. */
const PDF_PAGE_MARGIN_MM = 10; // 1 cm por lado

function escapeHtml(s) {
  if (s == null || s === '') return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export default {
  name: 'PrintWorkReport',

  created() {
    this.$root.$on('print-work-report-pdf', this.printPDF);
  },

  beforeDestroy() {
    this.$root.$off('print-work-report-pdf');
  },

  methods: {
    buildHtml(payload) {
      const thead = payload.columnLabels
        .map(
          label =>
            `<th style="text-align:left;padding:6px;border:1px solid #ccc;background:#fafafa;color:#b71c1c;">${escapeHtml(
              label
            )}</th>`
        )
        .join('');
      let tbody = '';
      if (payload.rows.length === 0) {
        const colspan = payload.columnLabels.length;
        tbody = `<tr><td colspan="${colspan}" style="padding:10px;border:1px solid #ccc;text-align:center;">${escapeHtml(
          payload.emptyMessage
        )}</td></tr>`;
      } else {
        tbody = payload.rows
          .map(
            cells =>
              `<tr>${cells
                .map(
                  c =>
                    `<td style="padding:6px;border:1px solid #ccc;">${escapeHtml(
                      c
                    )}</td>`
                )
                .join('')}</tr>`
          )
          .join('');
      }
      return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <style>
    body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #222; margin: 0; padding: 0; }
    h1 { font-size: 18px; color: #b71c1c; margin: 0 0 6px 0; }
    .meta { margin: 4px 0; color: #444; }
    table { width: 100%; border-collapse: collapse; margin-top: 14px; }
  </style>
</head>
<body>
  <h1>${escapeHtml(payload.title)}</h1>
  <p class="meta">${escapeHtml(payload.subtitle)}</p>
  <p class="meta">${escapeHtml(payload.periodLine)}</p>
  <p class="meta">${escapeHtml(payload.statusLine)}</p>
  <table>
    <thead><tr>${thead}</tr></thead>
    <tbody>${tbody}</tbody>
  </table>
</body>
</html>`;
    },

    async printPDF(payload) {
      this.$root.$emit('work-report-print-loading', true);
      try {
        const htmlData = this.buildHtml(payload);
        const safeName = (payload.fileName || 'ReporteTrabajos').replace(
          /[^\w-]/g,
          '_'
        );
        const opt = {
          margin: [
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM
          ],
          html2canvas: { scrollY: 0 },
          filename: `${safeName}.pdf`,
          jsPDF: {
            unit: 'mm',
            orientation: 'landscape',
            format: 'a4'
          }
        };
        const pdf = await html2pdf()
          .set(opt)
          .from(htmlData)
          .outputPdf();
        printJS({
          printable: btoa(pdf),
          type: 'pdf',
          base64: true
        });
      } catch (error) {
        console.error(
          'There was an error while generating work report PDF' + error
        );
      } finally {
        this.$root.$emit('work-report-print-loading', false);
      }
    }
  }
};
</script>
